import { defineComponent as k, useCssModule as T, inject as p, computed as m, createElementBlock as _, openBlock as r, normalizeClass as s, unref as t, createElementVNode as x, renderSlot as E, createCommentVNode as n, createBlock as w } from "vue";
import "lodash-es/cloneDeep";
import "lodash-es/get";
import f from "./Icon.js";
import { D as b } from "./DataView.keys-aSOnA4AD.js";
import "./Illustration.vue_vue_type_script_setup_true_lang-BBqgoJO8.js";
import "lodash-es/uniqueId";
import "@leaflink/snitch";
import { T as N } from "./Table.keys-LHQf6FEH.js";
import { _ as S } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const A = {
  key: 0,
  class: "tw-relative tw-h-4 tw-w-3"
}, B = /* @__PURE__ */ k({
  __name: "TableHeaderCell",
  props: {
    sortId: { default: "" }
  },
  setup(h) {
    const a = h, e = T(), l = p(N.key);
    if (!l)
      throw new Error("TableHeaderCell must be used within a Table component");
    const { density: i, hasActions: y } = l, { currentSortId: v, currentSortOrder: d, updateCurrentSort: u } = p(
      b.key,
      b.defaults
    ), c = m(() => !!a.sortId), o = m(() => v.value === a.sortId);
    function C() {
      c.value && typeof u == "function" && u(a.sortId, { shouldEmit: !0 });
    }
    return (I, O) => (r(), _("th", {
      class: s(["stash-table-header-cell tw-border-b tw-border-r tw-border-ice-200 tw-p-3 tw-text-xs tw-font-medium tw-text-ice-900", [
        t(e).root,
        {
          "tw-bg-white": !o.value,
          "stash-table-header-cell--sorted tw-bg-blue-100": o.value,
          [t(e)["root--density-compact"]]: t(i) === "compact",
          [t(e)["root--density-comfortable"]]: t(i) === "comfortable",
          [t(e)["has-actions"]]: t(y),
          "tw-cursor-pointer": c.value
        }
      ]]),
      "data-test": "stash-table-header-cell",
      onClick: C
    }, [
      x("div", {
        class: s(["tw-flex tw-justify-between", t(e)["content-wrapper"]])
      }, [
        E(I.$slots, "default"),
        c.value ? (r(), _("div", A, [
          !o.value || t(d) === "asc" ? (r(), w(f, {
            key: 0,
            class: s(["tw-absolute tw-text-ice-700", [t(e).caret, t(e)["caret-up"]]]),
            "data-test": "icon|caret-up",
            name: "caret-up",
            size: "dense"
          }, null, 8, ["class"])) : n("", !0),
          !o.value || t(d) === "desc" ? (r(), w(f, {
            key: 1,
            class: s(["tw-absolute tw-text-ice-700", [t(e).caret, t(e)["caret-down"]]]),
            "data-test": "icon|caret-down",
            name: "caret-down",
            size: "dense"
          }, null, 8, ["class"])) : n("", !0)
        ])) : n("", !0)
      ], 2)
    ], 2));
  }
}), j = "_root_14363_2", z = "_caret_14363_18", H = {
  root: j,
  "has-actions": "_has-actions_14363_14",
  "content-wrapper": "_content-wrapper_14363_14",
  "caret-up": "_caret-up_14363_18",
  "caret-down": "_caret-down_14363_22",
  caret: z,
  "root--density-comfortable": "_root--density-comfortable_14363_31"
}, M = {
  $style: H
}, G = /* @__PURE__ */ S(B, [["__cssModules", M]]);
export {
  G as default
};
//# sourceMappingURL=TableHeaderCell.js.map
